// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guess-comp[data-v-91960938]{margin-bottom:10px;display:flex;justify-content:flex-end}.guess-comp ul[data-v-91960938]{width:100%}.guess-comp ul li[data-v-91960938]{margin-bottom:5px;line-height:20px;text-align:left}", ""]);
// Exports
module.exports = exports;
